/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusUploadListResponseDto } from '../../models/lexplus-upload-list-response-dto';

export interface UploadsControllerFindAllPaginatedV1$Params {
  tagIDs?: Array<string>;
  nurFavoriten?: boolean;

/**
 * Page number to retrieve. If you provide invalid value the default page number will applied
 *
 * **Example:** 1
 *
 *
 * **Default Value:** 1
 */
  page?: number;

/**
 * Number of records per page.
 *
 *
 * **Example:** 20
 *
 *
 *
 * **Default Value:** 25
 *
 *
 *
 * **Max Value:** 100
 *
 *
 * If provided value is greater than max value, max value will be applied.
 */
  limit?: number;

/**
 * Filter by dateiTyp query param.
 *
 * **Format:** filter.dateiTyp={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.dateiTyp=$eq:John Doe&filter.dateiTyp=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.dateiTyp'?: Array<string>;

/**
 * Filter by uploadDokumentTypID query param.
 *
 * **Format:** filter.uploadDokumentTypID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.uploadDokumentTypID=$eq:John Doe&filter.uploadDokumentTypID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.uploadDokumentTypID'?: Array<string>;

/**
 * Filter by erstelltVonID query param.
 *
 * **Format:** filter.erstelltVonID={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.erstelltVonID=$eq:John Doe&filter.erstelltVonID=$in:John Doe
 *
 * **Available Operations**
 * - $eq
 *
 * - $in
 *
 * - $and
 *
 * - $or
 */
  'filter.erstelltVonID'?: Array<string>;

/**
 * Filter by erstelltAm query param.
 *
 * **Format:** filter.erstelltAm={$not}:OPERATION:VALUE
 *
 *
 *
 * **Example:** filter.erstelltAm=$gte:John Doe&filter.erstelltAm=$lte:John Doe
 *
 * **Available Operations**
 * - $gte
 *
 * - $lte
 *
 * - $and
 *
 * - $or
 */
  'filter.erstelltAm'?: Array<string>;

/**
 * Parameter to sort by.
 * To sort by multiple fields, just provide query param multiple types. The order in url defines an order of sorting
 *
 * **Format:** {fieldName}:{DIRECTION}
 *
 *
 * **Example:** sortBy=dateiname:DESC&sortBy=erstelltAm:DESC
 *
 *
 * **Default Value:** erstelltAm:DESC
 *
 * **Available Fields**
 * - dateiname
 *
 * - erstelltAm
 *
 * - dateiTyp
 *
 * - dateigroesse
 */
  sortBy?: Array<'dateiname:ASC' | 'dateiname:DESC' | 'erstelltAm:ASC' | 'erstelltAm:DESC' | 'dateiTyp:ASC' | 'dateiTyp:DESC' | 'dateigroesse:ASC' | 'dateigroesse:DESC'>;

/**
 * Search term to filter result values
 *
 * **Example:** John
 *
 *
 * **Default Value:** No default value
 */
  search?: string;

/**
 * List of fields to search by term to filter result values
 *
 * **Example:** 
 *
 *
 * **Default Value:** By default all fields mentioned below will be used to search by term
 *
 * **Available Fields**
 */
  searchBy?: Array<string>;

/**
 * List of fields to select.
 *
 * **Example:** uploadID,dateiname,beschreibung,dateiTyp,uploadDokumentTypID
 *
 *
 * **Default Value:** By default all fields returns. If you want to select only some fields, provide them in query param
 */
  select?: string;
}

export function uploadsControllerFindAllPaginatedV1(http: HttpClient, rootUrl: string, params?: UploadsControllerFindAllPaginatedV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusUploadListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, uploadsControllerFindAllPaginatedV1.PATH, 'get');
  if (params) {
    rb.query('tagIDs', params.tagIDs, {});
    rb.query('nurFavoriten', params.nurFavoriten, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('filter.dateiTyp', params['filter.dateiTyp'], {});
    rb.query('filter.uploadDokumentTypID', params['filter.uploadDokumentTypID'], {});
    rb.query('filter.erstelltVonID', params['filter.erstelltVonID'], {});
    rb.query('filter.erstelltAm', params['filter.erstelltAm'], {});
    rb.query('sortBy', params.sortBy, {});
    rb.query('search', params.search, {});
    rb.query('searchBy', params.searchBy, {});
    rb.query('select', params.select, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusUploadListResponseDto>;
    })
  );
}

uploadsControllerFindAllPaginatedV1.PATH = '/v1/uploads/paginated/all';
